import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Unsubscribable } from 'rxjs';
import { StorageService } from '../storageprovider';
import { DnFocusesService } from '../_service/dn-focus/dn-focus.service';
import { RegionService } from '../_service/region/region.service';

@Component({
  selector: 'div.share-top',
  templateUrl: './shared-topnav.component.html',
  styleUrls: ['./shared-topnav.component.scss']
})
export class SharedTopnavComponent implements OnInit, OnDestroy {
  fitems = [];
  private _subscriptions: Array<Unsubscribable> = [];
  constructor(private route: ActivatedRoute,
    private _dnFocusesService: DnFocusesService,
    private _storage: StorageService,
    private _regionService: RegionService
  ) { }
  ngOnDestroy(): void {
    this._subscriptions.forEach(p => p.unsubscribe());
  }
  shouldLoad = true;
  public cid = "0,1";
  private mapper(route) {
    switch (route) {
      case "movie":
        return "0,1,3";
      case "drama":
        return "0,1,4";
      case "variety":
        return "0,1,5";
      case "anime":
        return "0,1,6";
      case "documentary":
        return "0,1,7";
      default:
        return "0,1";
    }
  }
  lastKey = "";
  private getLastKey() {
    return "last_" + this.cid + "_" + (this._storage.GetConfig()["region"] || "GL.");
  }
  ngOnInit(): void {

    this._subscriptions.push(
      this.route.params.subscribe(p => {
        this.cid = this.mapper(p.route);

        this.getFlashBanner();
      }),

      this._regionService.region$.subscribe(region => {
        this.getFlashBanner();
      }),

    )
  }

  private getFlashBanner() {
    if (this.lastKey == this.getLastKey()) {
      return;
    }
    this.lastKey = this.getLastKey();
    this._dnFocusesService.getDnFocuses(this.cid, this._storage.GetConfig()["region"] || "GL.").subscribe(res => {
      this.fitems = res;
    })
  }

}
